// We just need some static string
export const STATIC_REDEEM_TOKEN = 'autybkauyu56127i312';
